import React, { useState, useEffect } from 'react'
import { CounterProps } from './Counter.types'

const Counter: React.FC<CounterProps> = ({ start, end, duration, prefix, suffix, onStart, onEnd }): JSX.Element => {
	const [counter, setCounter] = useState<number>(start)

	useEffect(() => {
		let startTime: number | null = null

		const animateCount = (timestamp: number) => {
			if (!startTime) startTime = timestamp
			const progress = (timestamp - startTime) / (duration * 1000)

			if (progress >= 1) {
				setCounter(end)
				if (onEnd) onEnd()
			} else {
				const diff = end - start
				const increment = Math.floor(diff * progress)
				setCounter(start + increment)
				requestAnimationFrame(animateCount)
			}
		}

		if (onStart) onStart()
		requestAnimationFrame(animateCount)
		// eslint-disable-next-line
	}, [])

	const getCountString = () => {
		let countString = `${Math.floor(counter)}`
		if (prefix) countString = `${prefix}${countString}`
		if (suffix) countString = `${countString}${suffix}`
		return countString
	}

	return <span>{getCountString()}</span>
}

export default Counter
